import globals from '../../common/globals';

export default {
  name: 'vx-campaign-fixed-menu',
  data() {
    return {
      globals,
      selected: 0,
      hideMenu: 1,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    if (screen.width <= 767) {
      this.hideMenu = 0;
    }

    // Removing Whitespace adding from SmarEdit
    const mainEl = document.querySelector('#brawny .main__inner-wrapper');
    if (mainEl) {
      mainEl.setAttribute('style', 'max-width:100%');
      mainEl.parentElement.setAttribute('style', '-ms-overflow-x: hidden');
    }

    const gtaEl = document.querySelector('.Brawny-gta-Main');
    const contFld = document.querySelector('.container-fluid');
    if(gtaEl && contFld) {
      jQuery(contFld).addClass('brawnyGTA');
    }

    const gaintsEl = document.querySelector('#giants-section');
    if (gaintsEl && window.location.hash) {
      if (window.location.hash === '#giants-section') {
        jQuery('html, body').animate({
          scrollTop: gaintsEl.offsetTop - 20,
        }, 10);
      }
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  props: {
    menus: {
      type: Array,
    },
  },
  methods: {
    handleScroll() {
      // Menu active while scrolling
      const header = document.querySelector('.header-section');
      const menuItem = document.querySelector('#giants-navbar');

      let headerHgt = '';
      if (header) {
        headerHgt = header.clientHeight;
      }

      let menuHgt = '';
      if (menuItem) {
        menuHgt = menuItem.clientHeight;
      }

      const currentTop = window.pageYOffset + headerHgt + menuHgt;

      const elems = jQuery('.Brawny-GTA');
      elems.each(function(index) {
        const elemTop = jQuery(this).offset().top;
        const elmHgt = jQuery(this).height();
        const elemBottom = elemTop + elmHgt;


        if (currentTop >= elemTop && currentTop <= elemBottom) {
          const id = jQuery(this).attr('id');
          const navElem = jQuery(`a[href="#${id}"]`);
          navElem.parent().addClass('active').siblings().removeClass('active');
        }
      });
    },
    selectedMenu(index) {
      this.selected = index;
      const currEl = this.menus[index].link;
      const el = document.querySelector(currEl);
      const menuItem = document.querySelector('#giants-navbar');

      let menuHgt = '';
      if (menuItem) {
        menuHgt = menuItem.clientHeight;
      }
      if (el) {
        jQuery('html, body').animate({
          scrollTop: el.offsetTop - menuHgt,
        }, 10);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-fixed-menu/vx-campaign-fixed-menu.js